<template>
	<button
		class="text-white bg-green-600 hover:bg-green-800 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
	>
		<slot />
	</button>
</template>
